__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/8b75e81/packs/";